// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { avoidBreakInsidePrintElement, color } from "@vanmeter/XDL/Utilities";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import { fontConfig } from "@vanmeter/XDL/constants";

interface OrderTotalDisplaySharedStyles {
    styledBoxStyles?: InjectableCss;
    mainContainer: GridContainerProps;
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelGridItem: GridItemProps;
    valueGridItem: GridItemProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    styledHr?: InjectableCss;
}

const label: TypographyPresentationProps = {
    ...fontConfig.smallSingleLine,
    weight: "normal",
    css: css`
        letter-spacing: 0;
    `,
};
const value: TypographyPresentationProps = {
    ...fontConfig.smallSingleLine,
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
        margin-left: auto;
    `,
};
export const orderTotalDisplaySharedStyles: OrderTotalDisplaySharedStyles = {
    mainContainer: {
        gap: 0,
        offsetCss: css`
            row-gap: 8px;
            &&& {
                @media print {
                    display: flex;
                }
            }
        `,
        css: css`
            ${avoidBreakInsidePrintElement}
        `,
    },
    titleText: {
        variant: "h5",
        forwardAs: "h2",
        css: css`
            margin: 0;
        `,
    },
    labelGridItem: {
        width: 7,
    },
    valueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 5,
    },
    label: {
        ...label,
    },
    value: {
        ...value,
    },
    totalLabel: {
        ...label,
        ...fontConfig.regularSingleLine,
    },
    totalValue: {
        ...value,
        ...fontConfig.regularSingleLine,
    },
    styledHr: {
        css: css`
            width: 100%;
            border: none;
            border-bottom: 1px solid ${color("common.border")};
            margin: 0;
        `,
    },
};
